export default {
    Writers: {word_limit: 75000, image_limit: 0},
    Authors: {word_limit: 275000, image_limit: 0},
    Designer: {word_limit: 0, image_limit: 450},
    Artist: {word_limit: 0, image_limit: 800},
    Basic: {word_limit: 45000, image_limit: 60},
    Pro: {word_limit: 150000, image_limit: 200},
    Trial: {word_limit: 1, image_limit: 1},
    Starter: {word_limit: 6000, image_limit: 20}
}